import { selectIsGoogleAdsConnected, useGoogleAdsOAuthStore } from "./use-google-ads-oauth-store";

interface IUseGoogleAdsOAuthReturn {
    isConnected: boolean;
    isConnecting: boolean;
    error: string | null;
    connect: () => Promise<void>;
    reset: () => void;
    // Evaluates expiry at call time, for event handlers that may run long after the last render.
    checkIsConnected: () => boolean;
}

// Every caller reads/writes the same underlying store (`use-google-ads-oauth-store.ts`), so a
// connection made by one caller (e.g. the import wizard) is immediately visible to another (e.g.
// the write-action flow) without a redundant OAuth prompt. The token itself never leaves the store.
// Minimal subscription for query hooks: whether a token exists, plus the non-secret id that
// partitions cached data per Google connection.
export const useGoogleAdsConnection = (): { isConnected: boolean; connectionId: number } => {
    const isConnected = useGoogleAdsOAuthStore(selectIsGoogleAdsConnected);
    const connectionId = useGoogleAdsOAuthStore((state) => state.connectionId);

    return { isConnected, connectionId };
};

export const useGoogleAdsOAuth = (): IUseGoogleAdsOAuthReturn => {
    const isConnected = useGoogleAdsOAuthStore(selectIsGoogleAdsConnected);
    const isConnecting = useGoogleAdsOAuthStore((state) => state.isConnecting);
    const error = useGoogleAdsOAuthStore((state) => state.error);
    const connect = useGoogleAdsOAuthStore((state) => state.connect);
    const reset = useGoogleAdsOAuthStore((state) => state.reset);

    const checkIsConnected = (): boolean => selectIsGoogleAdsConnected(useGoogleAdsOAuthStore.getState());

    return { isConnected, isConnecting, error, connect, reset, checkIsConnected };
};
